import { Component } from '@theme/component';

/** Reveals the active compact category without changing the page scroll position. */
class IGSubcollectionNav extends Component {
  /** @type {number | undefined} */
  #frame;

  connectedCallback() {
    super.connectedCallback();

    if (!window.matchMedia('(max-width: 749px)').matches) return;

    this.#frame = requestAnimationFrame(() => {
      const list = this.querySelector('.ig-subcollection-list--compact');
      const current = list?.querySelector('[aria-current="page"]');
      if (!list || !current || !this.isConnected) return;

      const listRect = list.getBoundingClientRect();
      const currentRect = current.getBoundingClientRect();
      const inset = 8;

      if (currentRect.right > listRect.right - inset) {
        list.scrollLeft += currentRect.right - listRect.right + inset;
      } else if (currentRect.left < listRect.left + inset) {
        list.scrollLeft += currentRect.left - listRect.left - inset;
      }
    });
  }

  disconnectedCallback() {
    if (this.#frame !== undefined) cancelAnimationFrame(this.#frame);
    super.disconnectedCallback();
  }
}

if (!customElements.get('ig-subcollection-nav')) {
  customElements.define('ig-subcollection-nav', IGSubcollectionNav);
}
